import { Link, useLocation, useNavigate } from "react-router";
import { useEffect, useState } from "react";
import Navbar from "./Navbar";

export default function Header(){

  let [showNavbar, setShowNavbar] = useState(false);
  let [headerWhite, setHeaderWhite] = useState(false);

  const location = useLocation()
  const navigate = useNavigate()

  const menuHandler = () => {
    setShowNavbar(!showNavbar);
  }

  useEffect(() => {
    let path = location.pathname;
    setHeaderWhite(!(path == "" || path == "/"))
    setShowNavbar(false)
  }, [location.pathname])

  return (
    <header className={`flex justify-between items-center h-40 w-full absolute top-0 px-5 lg:px-8 z-50 ${headerWhite ? "header-white" : ""}`}>
      <div onClick={() => navigate("/") } className="flex items-center cursor-pointer">
        <img className="h-16" src={ '/logo.svg' } alt="Pousada Casa Kuava" />
      </div>
      <Navbar show={showNavbar} />
      <div className="hidden lg:flex"> 
          <Link to="/reservar">
            <a className="py-2 w-32 px-8 text-white bg-stone-500 rounded">Reservar</a>
          </Link>
      </div>
      <div onClick={menuHandler} className="flex flex-wrap items-center w-10 h-10 mr-1 lg:hidden cursor-pointer">
          <span className={`block w-full h-1 bg-stone-500 rounded ${headerWhite ? 'bg-slate-500' : 'bg-white'}`}></span>
          <span className={`block w-full h-1 bg-stone-500 rounded ${headerWhite ? 'bg-slate-500' : 'bg-white'}`}></span>
          <span className={`block w-full h-1 bg-stone-500 rounded ${headerWhite ? 'bg-slate-500' : 'bg-white'}`}></span>
      </div>
    </header>
  )
}